module.exports = __webpack_public_path__ + "static/media/folder.b436c3e2.svg";